import React, { useState } from "react";
import botImg from "../../../images/ai1.webp";
import botImg2 from "../../../images/ai2.webp";

const AivoiceSection = () => {
  const [activeImg, setActiveImg] = useState(botImg);

  return (
    <>
      <style>{`
        .ai-section {
          padding: 4rem 1.5rem;
          background: #fff;
        }

        .ai-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .ai-title {
          text-align: center;
          font-size: 2.2rem;
          font-weight: 700;
          color: #9E104C;
          margin-bottom: 1rem;
        }

        .ai-desc {
          max-width: 800px;
          margin: 0 auto 3rem;
          text-align: center;
          color: #555;
        }

        .ai-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          align-items: center;
        }

        .ai-left {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .ai-card {
          background: #fafafa;
          padding: 1.8rem;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.05);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .ai-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 15px 35px rgba(158,16,76,0.2);
        }

        .ai-card h4 {
          color: #9E104C;
          margin-bottom: 0.5rem;
        }

        .ai-right img {
          width: 80%;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }

        @media (max-width: 768px) {
          .ai-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <section className="ai-section">
        <div className="ai-container">
          <h2 className="ai-title">AI Voice Automation</h2>
          <p className="ai-desc">
            Our AI Voice system lets customers interact using natural speech —
            no typing required. It understands intent and completes actions
            seamlessly.
          </p>

          <div className="ai-grid">
            {/* LEFT CONTENT */}
            <div className="ai-left">
              <div
                className="ai-card"
                onMouseEnter={() => setActiveImg(botImg)}
              >
                <h4>AI Voice Bot Flow</h4>
                <p>
                  The AI Voice Bot seamlessly guides users through the complete
                  journey using natural voice commands — from discovery and
                  selection to ordering, payment, and real-time updates. It
                  understands intent, adapts instantly, and delivers a smooth,
                  hands-free experience with zero manual effort.
                </p>
              </div>

              <div
                className="ai-card"
                onMouseEnter={() => setActiveImg(botImg2)}
              >
                <h4>Personalized AI Communication Logic</h4>
                <p>
                  Both voice and messaging automation are powered by advanced AI
                  that continuously learns from user behavior. Every interaction
                  helps the system deliver more accurate, relevant, and
                  personalized responses over time.
                </p>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="ai-right d-flex justify-content-center">
              <img src={activeImg} alt="AI Voice Bot" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AivoiceSection;
